
import { Task } from '../models/task';

export class Project {
    projNo: string = '';
    projName: string = '';
    expType: string = '';
    startDt: Date | undefined ;
    endDt: Date | undefined ;
    countTask: number = 0; 
    tasks: Array<Task> = new Array<Task>();

    get displayName(): string {
        return this.projNo + ': ' + this.projName;
    }

    static fromJSONArray(projects: Array<any>): Project[] {
        return projects.map(project => new Project(project));
    }

    constructor(project?: any) {
        if (!!project) {
            this.projNo = project['projNo'];
            this.projName = project['projName'];
            this.expType = project['expType'];
            this.startDt = project['startDt'];
            this.endDt = project['endDt'];
            this.countTask = project['countTask'];
            if (!!project['tasks']) {
                this.tasks = Task.fromJSONArray(project['tasks'])
            }
        }
    }
}

